import React from 'react';
interface OffersFullWidthBannerProps {
  imageUrl?: string;
}
export function OffersFullWidthBanner({
  imageUrl = ''
}: OffersFullWidthBannerProps) {
  return <div className="container mx-auto px-4" data-id="element-4762" data-mp="1bizr91tr1e50">
      <a href="#" className="relative block aspect-[14/3] overflow-hidden rounded-lg bg-gray-300" data-id="element-4763" data-mp="16gsc63dmhhyg">
        {imageUrl && <img src={imageUrl} alt="" className="absolute inset-0 h-full w-full object-cover" loading="lazy" decoding="async" data-id="element-4764" data-mp="12hjhmwardg1u" />}
        <div className="absolute inset-0 flex items-center justify-center" data-id="element-4765" data-mp="1u7wmb7wz0aoa">
          <div className="text-center text-gray-700" data-id="element-4766" data-mp="1pfczrlgb257c">
            <div className="mb-2 text-3xl font-bold md:text-4xl" data-id="element-4767" data-mp="1leszi90fqlgz">Full Width Promotional Banner</div>
            <div className="text-base md:text-lg" data-id="element-4768" data-mp="2hwpaujb9jg8v">Exclusive offers and deals</div>
          </div>
        </div>
        <div className="absolute bottom-3 left-3 rounded bg-black/60 px-3 py-1.5 text-xs text-white" data-id="element-4769" data-mp="2d68vuursnmke">
          1400×300 — 4.67:1
        </div>
      </a>
    </div>;
}